import React, { Component } from 'react';
import { GetResults } from './API';
import { withLocalize } from 'react-localize-redux';

 const ResultRow = (props) => {
    let langCode = 'en'
    if(props.activeLanguage !== undefined)
    {
      langCode = props.activeLanguage.code
    }
    return (
        <tr>
            <td>{props.item.crsNumE} </td>
            <td>{ langCode ==='ar' ? props.item.crsNameArabic : props.item.crsNameEnglish}</td>
            <td>{props.item.courseResult.crsAbsence}</td>
            <td>{props.item.courseResult.grade1} </td>
            <td>{props.item.courseResult.grade2}  </td>
            <td>{props.item.courseResult.grade3}  </td>
            <td>{props.item.courseResult.degreeSymbol}  </td>
        </tr>

    );
}
export default withLocalize( ResultRow)


// WEBPACK FOOTER //
// ./src/pages/results/ResultRow.js